import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { NgxMaterialTimepickerTheme } from 'ngx-material-timepicker';
import { Stringable, StringableValues } from '../../../../common/stringable.decorator';

const KEY = 'timepicker';

@Component({
  selector: 'atyl-timepicker',
  templateUrl: './timepicker.component.html',
  styleUrls: ['./timepicker.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
})
@Stringable({
  path: 'views/partials/layout/timepicker',
  key: KEY,
})
export class TimepickerComponent implements OnInit {

  @StringableValues(KEY)
  strings: any;

  @Input() disabled: boolean = false;
  @Input() toggleIcon: TemplateRef<HTMLObjectElement> = null;
  @Input() buttonAlign: string = 'right';
  @Input() cancelBtnTmpl: TemplateRef<Node>;
  @Input() confirmBtnTmpl: TemplateRef<Node>;
  @Input() defaultTime: string = '21:00';
  @Input() format: number = 24;
  @Input() value: string;
  @Input() clockTheme: NgxMaterialTimepickerTheme = {
    container: {
      bodyBackgroundColor: '#9da3f9',
      buttonColor: '#fff'
    },
    dial: {
      dialBackgroundColor: '#6fdad0', // the top box background color
    },
    clockFace: {
      clockFaceBackgroundColor: '#fff',
      clockHandColor: '#000',
      clockFaceTimeInactiveColor: '#000'
    }
  };
  @Input() color: any;
  @Input() minTime: any;
  @Input() maxTime: any;
  @Input() controlOnly: boolean = false;
  @Output() timeChanged = new EventEmitter<any>();

  @ViewChild('timepicker', { read: undefined, static: undefined }) timepicker: any;

  constructor(
    private changeDetectorRef: ChangeDetectorRef
  ) { }

  ngOnInit() {
  }
  ngOnChanges() {
    // hook up to the timepicker's service method to set the default time 
    // this is needed because the timepicker's ChangeDetectionStrategy is set to OnPush
    if (this.timepicker!=undefined 
    && this.timepicker
     && this.timepicker.timepickerService!=undefined
      && this.timepicker.timepickerService
      && this.defaultTime!=undefined
      &&  this.defaultTime
     ) {
	console.log("TimepickerComponent",this.timepicker.timepickerService,this.defaultTime);
    	this.timepicker.timepickerService.setDefaultTime(this.defaultTime);
    }
    this.changeDetectorRef.detectChanges();
  }


  timeChangedEvent(event: any) {
    this.timeChanged.emit(event);
  }
}
